
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { 
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { CampaignFormValues } from "./types/formTypes";

interface QuizToggleProps {
  form: UseFormReturn<CampaignFormValues>;
  onToggle: (enabled: boolean) => void;
}

const QuizToggle: React.FC<QuizToggleProps> = ({ form, onToggle }) => {
  return (
    <FormField
      control={form.control}
      name="has_quiz"
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <FormLabel className="text-base">Quiz inschakelen</FormLabel>
            <FormDescription>
              Moet de gebruiker een quiz invullen?
            </FormDescription>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={(checked) => {
                field.onChange(checked);
                onToggle(checked);
              }}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default QuizToggle;
